export default __webpack_public_path__ + "static/media/back-arrow-icon.84bc6723.svg";